export const PATH_TRACKER = '/:date';
export const PATH_TRACKER_SETTINGS = '/settings';
export const PATH_TRACKER_SETTINGS_MACRO = '/settings/macro';
export const PATH_TRACKER_MEAL = '/:date/meal-details/:dietMealId';
export const PATH_TRACKER_ADD_INGREDIENT = '/:date/meal-details/:dietMealId/add-ingredient';
export const PATH_TRACKER_ADD_INGREDIENT_SCAN_BARCODE =
  '/:date/meal-details/:dietMealId/add-ingredient/scan-barcode';

export const PATH_TRACKER_DESCRIBE_MEAL = '/describe-meal';
export const PATH_TRACKER_DESCRIBE_MANUAL_MEAL = '/describe-manual-meal';
export const PATH_TRACKER_DESCRIBE_MEAL_MEAL = '/describe-meal/meal-details/:dietMealId';
export const PATH_TRACKER_DESCRIBE_ADD_INGREDIENT =
  '/describe-meal/meal-details/:dietMealId/add-ingredient';
export const PATH_TRACKER_DESCRIBE_ADD_INGREDIENT_SCAN_BARCODE =
  '/describe-meal/meal-details/:dietMealId/add-ingredient/scan-barcode';

export const PATH_TRACKER_DESCRIBE_MEAL_VOICE = '/describe-meal/by-voice';

export const PATH_TRACKER_DESCRIBE_ACTIVITY = '/describe-activity';
export const PATH_TRACKER_DESCRIBE_ACTIVITY_VOICE = '/describe-activity/by-voice';
export const PATH_TRACKER_DESCRIBE_ACTIVITY_ACTIVITY_DETAILS =
  '/describe-activity/activity-details';

export const PATH_TRACKER_EDIT_ACTIVITY = '/:date/activity-details/:activityId';

export const PATH_TRACKER_SCAN_PLATE = '/scan-plate';
export const PATH_TRACKER_SCAN_PLATE_DETAILS = '/scan-plate/details';

export const PATH_TRACKER_SCAN_BARCODE = '/scan-barcode';

export const PATH_TRACKER_SCAN_LABEL = '/scan-label';
export const PATH_TRACKER_SCAN_LABEL_ANALYZING = '/scan-label/analyzing';

export const PATH_TRACKER_UPLOAD_IMAGE = '/upload-image';

export const PATH_TRACKER_ADD_PRODUCT = '/add-product';
export const PATH_TRACKER_ADD_INGREDIENT_ADD_PRODUCT =
  '/:date/meal-details/:dietMealId/add-ingredient/add-product';
export const PATH_TRACKER_ADD_INGREDIENT_ADD_PRODUCT_SCAN_LABEL =
  '/:date/meal-details/:dietMealId/add-ingredient/add-product/scan-label';
export const PATH_TRACKER_ADD_INGREDIENT_ADD_PRODUCT_SCAN_LABEL_ANALYZING =
  '/:date/meal-details/:dietMealId/add-ingredient/add-product/scan-label/analyzing';
export const PATH_TRACKER_DESCRIBE_ADD_INGREDIENT_ADD_PRODUCT =
  '/describe-meal/meal-details/:dietMealId/add-ingredient/add-product';
export const PATH_TRACKER_DESCRIBE_ADD_INGREDIENT_ADD_PRODUCT_SCAN_LABEL =
  '/describe-meal/meal-details/:dietMealId/add-ingredient/add-product/scan-label';
export const PATH_TRACKER_DESCRIBE_ADD_INGREDIENT_ADD_PRODUCT_SCAN_LABEL_ANALYZING =
  '/describe-meal/meal-details/:dietMealId/add-ingredient/add-product/scan-label/analyzing';
